import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export abstract class LffBaseCmpDirective implements OnDestroy {
  protected destroyed$: Subject<void> = new Subject();

  protected constructor() {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
